import { Row, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const formatAmount = (value) => {
  if (value === null || value === undefined) return "";
  const clean = value.toString().replace(/[^0-9.]/g, "");
  const num = Number(clean);
  if (isNaN(num)) return value;
  return num.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

const SocialServicesTable = ({ viewMode = "graphs" }) => {
  const tableData = [
    {
      department: "Department of Health & Human Services (DHHS)",
      amount: "8372",
      share: "80.50%",
      color: "#A2C4C990",
    },
    {
      department: "Department of Workforce Services (DWS)",
      amount: "1723",
      share: "16.57%",
      color: "#DD7E6B90",
    },
    {
      department:
        "Other Small Social Services/Administrative Support Functions",
      amount: "305",
      share: "2.93%",
      color: "#38761D90",
    },
  ];

  const totalAmount = tableData.reduce(
    (sum, row) => sum + Number(row.amount),
    0
  );

  const totalShare = tableData.reduce(
    (sum, row) => sum + parseFloat(row.share.replace("%", "")),
    0
  );

  const chartLabels = tableData.map((row) => row.department);
  const chartValues = tableData.map((row) =>
    parseFloat(row.amount.replace(/[^0-9.]/g, ""))
  );
  const chartColors = tableData.map((row) => row.color.replace("90", ""));

  const chartData = {
    labels: chartLabels,
    datasets: [
      {
        label: "Amount ($ Million)",
        data: chartValues,
        backgroundColor: chartColors,
        borderRadius: 8,
        barThickness: 35,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    indexAxis: "y",
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${formatAmount(ctx.raw)}`,
        },
      },
      datalabels: {
        display: true,
        color: "#000",
        anchor: "end",
        align: "right",
        formatter: (value) => formatAmount(value),
        font: { weight: "bold", size: 13 },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Amount ($ Million)",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: { color: "#333" },
        grid: { display: true, color: "#ddd" },
      },
      y: {
        title: {
          display: true,
          text: "Department",
          color: "#111",
          font: { weight: "bold" },
        },
        ticks: {
          color: "#111",
          font: { size: 12, weight: "500" },
        },
        grid: { display: false },
        categoryPercentage: 0.4,
        barPercentage: 0.7,
      },
    },
  };

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h3>
        Social Services Budget Overview ($
        {Number("10400").toLocaleString("en-US")} Million, 34%){" "}
      </h3>{" "}
      <Row className="gy-4 flex items-center">
        {viewMode === "tables" && (
          <Col md={12}>
            <div className="overflow-x-auto flex items-center">
              <table className="w-full border-collapse text-center border shadow-md overflow-hidden mt-4">
                <thead>
                  <tr>
                    <th
                      className="p-2 text-left border"
                      style={{ backgroundColor: "#bfdbfe" }}
                    >
                      Department
                    </th>
                    <th
                      className="p-2 text-right border "
                      style={{ backgroundColor: "#bfdbfe" }}
                    >
                      Amount ($ Million)
                    </th>
                    <th
                      className="p-2 text-right border"
                      style={{ backgroundColor: "#bfdbfe" }}
                    >
                      Share of Social Services
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {tableData.map((row, index) => (
                    <tr
                      key={index}
                      className="odd:bg-gray-100 even:bg-white hover:bg-gray-100 transition border"
                    >
                      <td className="p-2 text-left border">{row.department}</td>
                      <td className="p-2 text-right border">
                        {formatAmount(row.amount)}
                      </td>
                      <td className="p-2 text-right border">{row.share}</td>
                    </tr>
                  ))}

                  <tr className="bg-blue-50 font-semibold border-t-2">
                    <td className="p-2 text-left border">Total</td>
                    <td className="p-2 text-right border">
                      {formatAmount(totalAmount)}
                    </td>
                    <td className="p-2 text-right border">{totalShare}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        )}
        {viewMode === "graphs" && (
          <Col md={12}>
            <div className="overflow-x-auto">
              <div className="p-3 bg-white rounded-3 border min-w-[900px] sm:min-w-full">
                <Bar data={chartData} options={chartOptions} />
              </div>
            </div>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default SocialServicesTable;
